module.exports = __webpack_public_path__ + "img/mxn.16ce3809.svg";